import React, { Fragment, useEffect, useState } from "react";
import Header from "../Components/Reuseable/Header";
import Auth from "../Components/Reuseable/Auth";
import Search from "../Components/Home/Components/Search";
import ExNews from "../Components/Home/Components/ExNews";
import Notification from "../Components/Home/Components/Notification";
import Tracker from "../Components/Home/Components/Tracker";
import { Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getUserDetails } from "../redux/postReducer/UserPost";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { Country_Name } from "../Components/Reuseable/Country";
import { useTranslation } from "react-i18next";
import { fetchsingleUser, STATUSES } from "../redux/getReducer/getSingleUser";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import { ImCross } from "react-icons/im";
import Language from "../Components/Home/Components/Language";
import Select from "react-select";
import Footer from "../Components/Reuseable/Footer";
import Copyrights from "../Components/Reuseable/Copyrights";

import { getBaseUrl } from "../service/apiUrl";
// Isolated Style Import
// import "./MyProfileNew.css"; 

const MyProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  const { data: singleUser, status } = useSelector((state) => state.singleUser);
  const cookiedata = Cookies.get("i18next");
  const [PassportPicture, setPassportPicture] = useState();
  const [IsPassportPicture, setIsPassportPicture] = useState(false);
  const [ProfilePicture, setProfilePicture] = useState();
  const [IsProfilePicture, setIsProfilePicture] = useState(false);
  const [NationalityID, setNationalityID] = useState("");
  const [preview, setPreview] = useState();
  const [preview1, setPreview1] = useState();
  const ProfileId = Cookies.get("id");

  const [state1, setState] = useState({
    FirstName: "",
    LastName: "",
    PassportNo: "",
    PhoneNumber: "",
    PassportPicture: PassportPicture,
    ProfilePicture:ProfilePicture,
    Email: "",
    NationalityID: "",
    Address: "",
    DOB: "",
  });

  const [validated, setValidated] = useState(false);
  const [state, setState1] = useState({ Password: "", ConfirmPassword: "" });
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setState1({ ...state, Password: newPassword });
    if (newPassword.length < 6) { setPasswordError("Password must be at least 6 characters"); } else { setPasswordError(""); }
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setState1({ ...state, ConfirmPassword: newConfirmPassword });
    if (newConfirmPassword !== state.Password) { setConfirmPasswordError("Passwords do not match"); } else { setConfirmPasswordError(""); }
  };

  useEffect(() => {
    if (singleUser) {
      setState({
        FirstName: singleUser.FirstName,
        LastName: singleUser.LastName,
        PassportNo: singleUser.PassportNo,
        PhoneNumber: singleUser.PhoneNumber,
        Email: singleUser.Email,
        NationalityID: singleUser.Nationality,
        Address: singleUser.Address,
        DOB: singleUser.DOB,
      });
    }
  }, [singleUser]);

  useEffect(() => { dispatch(fetchsingleUser()); }, [dispatch]);

  useEffect(() => {
    if (ProfilePicture === undefined) { setPreview(singleUser?.ProfilePicture); return; }
    const objectUrl = URL.createObjectURL(ProfilePicture);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [singleUser?.ProfilePicture, ProfilePicture]);

  useEffect(() => {
    if (PassportPicture === undefined) { setPreview1(singleUser?.PassportPicture); return; }
    const objectUrl = URL.createObjectURL(PassportPicture);
    setPreview1(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [singleUser?.PassportPicture, PassportPicture]);

  if (status === STATUSES.LOADING) { return <Lottie animationData={Animate} className="load" />; }
  if (status === STATUSES.ERROR) { return <h2 style={{ margin: "100px" }}>Something went wrong!</h2>; }

  const onSelectFileProfile = (e) => { setProfilePicture(e.target.files[0]); };
  const onSelectFilePassport = (e) => { setPassportPicture(e.target.files[0]); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("FirstName", state1.FirstName);
      formData.append("LastName", state1.LastName);
      formData.append("PassportNo", state1.PassportNo);
      formData.append("PhoneNumber", state1.PhoneNumber);
      formData.append("Nationality", NationalityID ? NationalityID : state1.NationalityID);
      if (state.Password !== "") { formData.append("password", state.Password); }
      formData.append("DOB", state1.DOB);
      formData.append("Address", state1.Address);
      formData.append("PassportPicture", PassportPicture);
      formData.append("ProfilePicture", ProfilePicture);
      if (IsPassportPicture === true && PassportPicture === undefined) { formData.append("deletePassportPicture", IsPassportPicture) }
      if (IsProfilePicture === true && ProfilePicture === undefined) { formData.append("deleteProfilePicture", IsProfilePicture) }
      await axios.put(`${getBaseUrl()}/updatesubscriber/${ProfileId}`, formData,{headers: {Authorization: Cookies.get('token')}});
      toast("Successfuly Updated");
      dispatch(fetchsingleUser());
      dispatch(getUserDetails());
    } catch (error) { toast(error.response.data.message); }
  };

  const handlePreview1 = () => { setPassportPicture(); setPreview1(); setIsPassportPicture(true); };
  const date = new Date(state1.DOB);

  return (
    <Fragment>
      <div className="new-profile-page-container">
        {/* Banner Section */}
        <div className="common-page-banner">
          <h1>{t("Profile Overview")}</h1>
        </div>

        {/* Main Card */}
        <div className="new-card-wrapper">
          <div className="new-main-white-card">
            
            {/* Row 1: Profile identity */}
            <div className="new-section-header">
              <div className="new-user-identity">
                <div className="new-avatar-container">
                  <div className="new-profile-circle-box">
                    {preview ? <img src={preview} alt="Profile" /> : <span>U</span>}
                  </div>
                  <label htmlFor="profileUpload" className="new-upload-overlay">
                    <i className="fa fa-camera"></i>
                  </label>
                  <input id="profileUpload" type="file" style={{display:'none'}} onChange={onSelectFileProfile} />
                </div>
                <div className="new-user-text">
                  <h2>{state1.FirstName} {state1.LastName}</h2>
                </div>
              </div>
              <div className="new-edit-link">{t("Edit Profile")}</div>
            </div>

            {/* Row 2: Form Fields Grouped */}
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="new-form-grid-layout">
                
                {/* Row 1: Name and Last name */}
                <div className="new-input-group">
                  <label>{t("First Name")}</label>
                  <Form.Control className="new-custom-input" type="text" value={state1.FirstName} onChange={(e) => setState({ ...state1, FirstName: e.target.value })} required />
                </div>
                <div className="new-input-group">
                  <label>{t("Last Name")}</label>
                  <Form.Control className="new-custom-input" type="text" value={state1.LastName} onChange={(e) => setState({ ...state1, LastName: e.target.value })} required />
                </div>

                {/* Row 2: Email and DOB */}
                <div className="new-input-group">
                  <label>{t("Email")}</label>
                  <Form.Control className="new-custom-input" type="email" value={state1.Email} readOnly />
                </div>
                <div className="new-input-group">
                  <label>{t("Date of Birth")}</label>
                  <Form.Control className="new-custom-input" type="text" value={date.toDateString()} readOnly />
                </div>

                {/* Row 3: Phone and Passport No */}
                <div className="new-input-group">
                  <label>{t("Phone Number")}</label>
                  <Form.Control className="new-custom-input" type="text" value={state1.PhoneNumber} onChange={(e) => setState({ ...state1, PhoneNumber: e.target.value })} required />
                </div>
                <div className="new-input-group">
                  <label>{t("Passport No")}</label>
                  <Form.Control className="new-custom-input" type="text" value={state1.PassportNo} onChange={(e) => setState({ ...state1, PassportNo: e.target.value })} required />
                </div>

                {/* Row 4: Address and Nationality */}
                <div className="new-input-group">
                  <label>{t("Address")}</label>
                  <Form.Control className="new-custom-input" type="text" value={state1.Address} onChange={(e) => setState({ ...state1, Address: e.target.value })} required />
                </div>
                <div className="new-input-group">
                  <label>{t("Nationality")}</label>
                  <Form.Select className="new-custom-input" value={NationalityID === "" ? state1?.NationalityID : NationalityID} onChange={(e) => setNationalityID(e.target.value)} required>
                    {Country_Name.map((item, i) => (
                      <option key={i} value={item.country_name}>{item.country_name}</option>
                    ))}
                  </Form.Select>
                </div>

                {/* Row 5: Password and Confirm password */}
                <div className="new-input-group">
                  <label>{t("Password")}</label>
                  <Form.Control className="new-custom-input" type="password" placeholder="••••••" value={state.Password} onChange={handlePasswordChange} />
                  {passwordError && <div className="new-error-text">{passwordError}</div>}
                </div>
                <div className="new-input-group">
                  <label>{t("Confirm Password")}</label>
                  <Form.Control className="new-custom-input" type="password" placeholder="••••••" value={state.ConfirmPassword} onChange={handleConfirmPasswordChange} />
                  {confirmPasswordError && <div className="new-error-text">{confirmPasswordError}</div>}
                </div>

                {/* Row 6: Passport picture */}
                <div className="new-input-group new-full-width-row">
                  <label>{t("Passport Picture")}</label>
                  <Form.Control className="new-custom-input" type="file" onChange={onSelectFilePassport} />
                  {preview1 && (
                    <div className="new-thumb-container">
                      <ImCross onClick={handlePreview1} className="crossIcon" style={{position:'absolute', top:'-5px', right:'-5px', fontSize:'10px', background:'red', color:'white', padding:'3px', borderRadius:'50%', cursor:'pointer'}} />
                      <img src={preview1} className="new-thumbnail-img" alt="Passport" />
                    </div>
                  )}
                </div>

              </div>

              {/* Section 3: Update Button */}
              <div className="new-footer-action">
                <Button className="new-update-btn-style" disabled={confirmPasswordError !== ""} type="submit">
                  {t("Update")}
                </Button>
              </div>
            </Form>
          </div>
        </div>

        <Footer />
        <Copyrights />
      </div>
    </Fragment>
  );
};

export default MyProfile;